import axios from "./axios";
import { server } from "./constants";

// ===========================
// =  Cart Manager Function  =
// ===========================

/**
 * Add item to cart ( add to local storage )
 * @param {{id: String, title: String, price: Number, quantity: Number, type: String}} param 
 * @return {object} Current items in cart
 */
const addItem = ({ id, title, price, quantity, type }) => {
    if (!quantity) quantity = 1;
    let cartItems = JSON.parse(localStorage.getItem(server.CART_ITEM));
    if (!cartItems) {
        cartItems = {};
        cartItems[id] = { title, price, quantity, type };
    }
    else {
        if (cartItems[id]) {
            cartItems[id].quantity += quantity;
        } else {
            cartItems[id] = { title, price, quantity, type };
        }
    }
    localStorage.setItem(server.CART_ITEM, JSON.stringify(cartItems));
    return cartItems;
}

/**
 * Remove item in cart ( remove in local storage )
 * @param {String} id 
 * @return {object} Current items in cart
 */
const removeItem = (id) => {
    let cartItems = JSON.parse(localStorage.getItem(server.CART_ITEM));
    cartItems[id].quantity--;
    if (cartItems[id].quantity == 0) { delete cartItems[id]; }
    localStorage.setItem(server.CART_ITEM, JSON.stringify(cartItems));
    return cartItems;
}

/**
 * Remove all items in cart
 */
const clearItems = () => {
    localStorage.setItem(server.CART_ITEM, "{}");
}

export default {
    addItem,
    removeItem,
    clearItems,
}